import React, {
  useEffect,
  useRef,
  useCallback
} from 'react';
import {
  useSlateStatic,
  ReactEditor,
} from 'slate-react';

import { mount, unmount } from 'redom';

import Helpers from '../../helpers';

import BaseElement from '../base';

import Product from './';

import './index.scss';

function ProductWrapper(props) {

  const element = props.element;

  const productContainerReference = useRef(null);
  const productReference = useRef(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const productChangeCallback = useCallback(handleProductChange, []);
  const editor = useSlateStatic();
  const elementPath = ReactEditor.findPath(editor, element);

  useEffect(function onLoad() {

    return initialize();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function initializeProduct() {

    const product = new Product({
      ...(element.options || {}),
      onChange: productChangeCallback
    });

    productReference.current = product;

    mount(productContainerReference.current, product);

    return product;

  }

  function initialize() {

    const productContainer = productContainerReference.current;
    console.log(productContainer);
    const product = initializeProduct();

    return function onUnload() {

      unmount(productContainer, product);

    };

  }

  function handleProductChange(options) {

    Helpers.setAttributes(editor, {
      options
    }, elementPath);

  }

  function renderProduct() {

    const mainAttributes = {
      ...props.attributes,
      className: 'product-element',
      contentEditable: false
    };

    const containerAttributes = {
      className: 'product-element-container',
      ref: productContainerReference,
      contentEditable: false,
      style: {
        userselect: 'none'
      }
    };

    return <div {...mainAttributes}>
      <div {...containerAttributes}>
      </div>
      {props.children}
    </div>;

  }

  function renderMain() {

    const baseElementProperties = {
      ...props,
      placeholder: '',
      className: 'product-wrapper'
    };

    return <BaseElement {...baseElementProperties}>
      {renderProduct()}
    </BaseElement>;

  }

  return renderMain();

}

export default ProductWrapper;